<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<app-more-sections label="shared|identity-card|title">
			<div>
				<app-input-field
					formControlName="identityDocumentNumber"
					[label]="
						'customers|record|driver-section|field-label|identity-document-number'
					" />
			</div>

			<div>
				<app-single-dropdown
					formControlName="identityDocumentType"
					[label]="
						'customers|record|driver-section|dropdown-label|identity-document-type'
					"
					[selectOptions]="customerIdentityDocumentTypes" />

				<app-single-dropdown
					[selectOptions]="countries"
					formControlName="identityDocumentIssuedByCountryId"
					[label]="
						'customers|record|driver-section|dropdown-label|identity-document-issued-by-country'
					" />
			</div>

			<div>
				<app-datetime-picker
					[showTime]="false"
					[excludeFutureDates]="true"
					formControlName="identityDocumentIssueDate"
					[label]="
						'customers|record|driver-section|field-label|identity-document-issue-date'
					" />
				<app-datetime-picker
					[showTime]="false"
					[excludePastDates]="true"
					formControlName="identityDocumentExpiryDate"
					[label]="
						'customers|record|driver-section|field-label|identity-document-expiry-date'
					" />
			</div>
		</app-more-sections>

		<app-more-sections label="shared|driving-license|title">
			<div>
				<app-input-field
					formControlName="drivingLicenseNumber"
					[label]="
						'customers|record|driver-section|field-label|driving-license-number'
					" />
			</div>

			<div>
				<app-input-field
					formControlName="drivingLicenseCategory"
					[label]="
						'customers|record|driver-section|field-label|driving-license-category'
					" />

				<app-single-dropdown
					[selectOptions]="countries"
					formControlName="drivingLicenseIssuedByCountryId"
					[label]="
						'customers|record|driver-section|dropdown-label|driving-license-issued-by-country'
					" />
			</div>

			<div>
				<app-datetime-picker
					formControlName="drivingLicenseIssueDate"
					[showTime]="false"
					[excludeFutureDates]="true"
					[label]="
						'customers|record|driver-section|field-label|driving-license-issue-date'
					" />

				<app-datetime-picker
					formControlName="drivingLicenseExpiryDate"
					[showTime]="false"
					[excludePastDates]="true"
					[label]="
						'customers|record|driver-section|field-label|driving-license-expiry-date'
					" />
			</div>
		</app-more-sections>
	</form>
</app-section-wrapper-container>
